import { supabase } from '@/integrations/supabase/client';

export interface AdminActivityParams {
  activityType: string;
  description: string;
  resourceType?: string;
  resourceId?: string;
  beforeState?: any;
  afterState?: any;
}

export const logAdminActivity = async (params: AdminActivityParams): Promise<boolean> => {
  try {
    // Get admin email from localStorage - check both admin_* and user_* prefixes (unified login)
    const adminEmail = localStorage.getItem('admin_auth_email') 
      || localStorage.getItem('user_auth_email');
    if (!adminEmail) {
      console.warn('Admin email not found in localStorage (checked admin_auth_email and user_auth_email)');
      return false;
    }

    // Get token for authentication - check both prefixes
    const token = localStorage.getItem('admin_auth_token') 
      || localStorage.getItem('user_auth_token');
    if (!token) {
      console.warn('Admin token not found (checked admin_auth_token and user_auth_token)');
      return false;
    }

    const { data, error } = await supabase.functions.invoke('log-admin-activity', {
      body: {
        activityType: params.activityType,
        description: params.description,
        resourceType: params.resourceType,
        resourceId: params.resourceId,
        beforeState: params.beforeState,
        afterState: params.afterState,
        adminEmail,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (error) {
      console.error('Failed to log admin activity:', error);
      return false;
    }

    return data?.success || false;
  } catch (error) {
    console.error('Error logging admin activity:', error);
    return false;
  }
};
